// removed by extract-text-webpack-plugin
module.exports = {"RecommendationTile":"RecommendationTile__RecommendationTile__1CYY0","RecommendationLink":"RecommendationTile__RecommendationLink__1UjyD","RecommendationTitle":"RecommendationTile__RecommendationTitle__2IVyX","RecommendationText":"RecommendationTile__RecommendationText__2PoUu","container":"RecommendationTile__container__21ucb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExperiencesLandingPage/RecommendationTile/RecommendationTile.scss
// module id = 683
// module chunks = 0